/** What a panel shows before the round is opened. Every box says the same
    thing, and then says what it will hold once trading starts. */
export function Standby({ note }: { note: string }) {
  return (
    <div className="standby">
      <span className="standby__pulse" aria-hidden="true" />
      <p className="standby__title">COMPETITION STARTING SOON</p>
      <p className="standby__note">{note}</p>
    </div>
  )
}
